// @flow

// NOTE:
// app/models/officer_approval/vote.rbの定義を参照
export const VOTE_DELEGATE = 30;
